module.exports = __webpack_public_path__ + "img/mx.47e5ff21.png";